declare global {
  const REACT_APP_ASSETS_DOMAIN: string | null;

  // PDFTron config files SHA1
  const PDFTRON_CONFIG_BASE_SHA1: string | null;
  const PDFTRON_CONFIG_SIGN_SHA1: string | null;
  const PDFTRON_CONFIG_CREATE_SIGN_SHA1: string | null;

  // Zoom Integration
  const ZOOM_CLIENT_ID: string | null;
  const ZOOM_OAUTH_REDIRECT_URL: string | null;
}

export function useCardboardEnv() {
  return {
    REACT_APP_ASSETS_DOMAIN: REACT_APP_ASSETS_DOMAIN,
    PDFTRON_CONFIG_BASE_SHA1: PDFTRON_CONFIG_BASE_SHA1,
    PDFTRON_CONFIG_SIGN_SHA1: PDFTRON_CONFIG_SIGN_SHA1,
    PDFTRON_CONFIG_CREATE_SIGN_SHA1: PDFTRON_CONFIG_CREATE_SIGN_SHA1,
  };
}
